export const HERO_CONSTANTS = {
  button: {
    label: "Upgrade your IT skills with certification labs",
    link: "#contact-us",
  },
  title: "Cloud-Based Training & Certification Labs",
};
